<div class="container-gallery" [class.no-widgets]="!hasWidgets">
  <app-gallery-destination
    [images]="homeItemDetail.banners"
    [hasWidgets]="hasWidgets"
    (trackEvent)="trackEvent.emit($event)">
  </app-gallery-destination>
</div>